import UploadFileTile from 'components/UploadFile/UploadFileTile';
import UploadManyTile from 'components/UploadFile/UploadManyTile';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { Stack, Typography } from 'styles';
import { STATE_KEYS } from 'types/Store';
import { DocType } from 'types/Upload';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

const docList: DocType[] = ['prescription', 'receipt'];

const Documentation = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { claimData } = useSelector((store: RootState) => store.claim);

	return (
		<Stack gap={'25px'}>
			<Typography variant="title6">
				{tClientLabels('claim.review.documentation')}
			</Typography>
			<Stack direction={'row'} gap="40px" alignItems={'flex-start'}>
				{docList.map((doc, index) => {
					if (doc === 'other') {
						return (
							<UploadManyTile
								key={index}
								documentType={doc}
								data={claimData.attachments['others']}
							/>
						);
					} else {
						return (
							<UploadFileTile
								key={index}
								label={tClientLabels(`newClaim.upload.docNames.${doc}`)}
								labelUpload={tClientLabels(`newClaim.upload.docNames.${doc}`)}
								documentType={doc}
								data={claimData.attachments[doc]}
								clearDocumentsKey={STATE_KEYS.CLAIM}
							/>
						);
					}
				})}
			</Stack>
		</Stack>
	);
};

export default Documentation;
